import React, { useEffect,useState } from "react";
import Router from 'next/router'

const ReviewPageRredirect = ()=>{
    const [loaded,setLoaded] = useState(false)
    useEffect(() => {
        const {pathname} = Router
        // conditional redirect
        if(pathname == '/hotel/review' ) {
            // with router.push the page may be added to history
            // the browser on history back will  go back to this page and then forward again to the redirected page
            // you can prevent this behaviour using location.replace
            Router.push('/hotels/reviews')
           //location.replace("/hello-nextjs")
        }else{
            setLoaded(true)
        }
      },[]);

    if(!loaded){
        return <div style={{
          margin: 'auto',
          width: '60px',
          height: '60px',
          backgroundColor: '#c19237',
          borderRadius: '100%',
          animation: 'pulseScaleOut 1s infinite ease-in-out'
        }}></div>
    }
    return ( 
        <p>
            You will see this page only if pathname !== /review , <br/>
        </p> 
    )
}
export default ReviewPageRredirect